const pileShape = {
    'Kołowy': 1.2, 
    'Kwadratowy': 1.4
};

export default pileShape;